// import React, { Component } from "react";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import { USERGET_DATA} from "../service/apiUrl";
import { useSelector } from "react-redux";
import { postApiCall } from "../service/PostApiCall";
import { INVENTORY_UPDATE, VIEW_INVENTORY } from "../service/apiUrl";
import { useNavigate, useParams } from "react-router-dom";
import { STRING } from "../constants/string";
import Utils from "../utility/utility";
import { Link } from "react-router-dom";
import LoadingButton from "../components/LoadingButton";

const FieldError = ({ msg }) => (
  <span className={"field-error" + (msg ? " is-shown" : "")}>{msg || ""}</span>
);

const EditInveintory = (props) => {
  const {inventory_id} = useParams();
  const [errors, setErrors] = useState({});
  const [name , setName] = useState("");
  const [serialno , setSerialNo] = useState("");
  const [brand , setBrand] = useState();
  const [type , setType] = useState("");
  console.log ("type111" ,type?.value)
  const [assign , setAssign] = useState("");
  const navigate = useNavigate();
  const validateannouncement = () => {
    let message = "";
        const e = {};
    if (Utils.isEmpty(name)) e.name = STRING.NAME;
    if (Utils.isEmpty(serialno)) e.serialno = STRING.SERIALNO;
    if (Utils.isEmpty(brand)) e.brand = STRING.BRAND;
    if (Utils.isEmpty(type)) e.type = STRING.TYPE;
    if (Utils.isEmpty(assign)) e.assign = STRING.ASSIGN;
    setErrors(e);
    message = Object.keys(e).length ? "invalid" : "";

    return message;
  };
  const updateInventort = ()=>{
    const message = validateannouncement();
    if (message) {
      return false;
    } else{
    const data = {
      id : inventory_id,
      name : name,
      brand : brand,
      type : type?.value,
      serial_number : serialno,
      assign_to : assign?.value,

    }
    return postApiCall(data, signdata?.data?.access_token,  INVENTORY_UPDATE)
    .then((result) => {
      navigate("/inventory-listing");
      Utils.toast("success", STRING.INVENTORY_SUCCESSFUL_UPDATE );
    })
    .catch((error) => {
      console.error("USER_HELPER", error);
      throw error;
    });
  }
  }
const signdata = useSelector((state) => state.signinReducers);
const [typeOption , setOption] = useState([]);
const [helperData, setHelperData] = useState([]);
useEffect(()=>{
  const type = [
    {value : 'keyboard',label : 'Keyboard'},
    {value : "mouse",label : "Mouse"},
    {value : "destop",label : "Destop"},
    {value : "cpu",label : "CPU"},
    {value : "UPS",label : "UPS"},
    {value : "laptop",label : "Laptop"},
    {value : "datacable",label : "Datacable"},
    {value : "ctype datacable",label : "Ctype Datacable"},
    {value : "mobile",label : "Mobile"},
    {value : "multiport",label : "Multiport"},
   ]
   setOption(type)
},[])
useEffect(() => {
  postApiCall([], signdata?.data?.access_token, USERGET_DATA)
    .then((result) => {
      setHelperData(result?.all_users);
    })
    .catch((error) => {
      console.error("USER_HELPER", error);
    });
}, []);

useEffect(()=>{
  const id = {
    id : inventory_id
  }
  postApiCall(id, signdata?.data?.access_token, VIEW_INVENTORY )
  .then((result) => {
   console.log("result11111" , result)
   setName(result?.name)
   setSerialNo(result?.serial_number)
   setBrand(result?.brand)
   setType({label : result?.type ,value : result?.type})
   setAssign({label : result?.first_name+' '+result?.last_name ,value : result?.assign_to})
  })
  .catch((error) => {
    console.error("USER_HELPER", error);
  });
},[])
  return (
    <>
      <div className={props?.data?.transtion == true ? "contents" : "content"}>
        <div className="content-top-spacer"></div>
        <div className="color-body">
          <div className="page-head">
            <div className="page-eyebrow">Workplace</div>
            <h1 className="page-title">Edit Inventory</h1>
          </div>
          <div className="col-md-6 manage">
            <div className="card-input mt-5 mb-2">
              <div className="col-md-12">
                {/* <div className="mt-3">
                  <h5 className="border-bottom pb-2">Create Inventory</h5>
                </div> */}
                <form>
                  <div className="row mt-3">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="exampleInputEmail1">Name</label>
                        <input
                          type="text"
                          value={name}
                          className={"form-control" + (errors.name ? " is-invalid" : "")}
                          onChange={(data)=>{
                            setName(data.target.value)
                          }}

                          // placeholder="Enter Project Owner"
                        />
<FieldError msg={errors.name} />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="exampleInputEmail1">
                          Serial Number
                        </label>
                        <input
                          type="text"
                          className={"form-control" + (errors.serialno ? " is-invalid" : "")}
                          value={serialno}
                          onChange={(data)=>{
                            setSerialNo(data.target.value)
                          }}

                          // placeholder="Enter Project Owner"
                        />
<FieldError msg={errors.serialno} />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="exampleInputEmail1">Brand</label>
                        <input
                          type="text"
                          className={"form-control" + (errors.assign ? " is-invalid" : "")}
                          value={brand}
                          onChange={(data)=>{
                            setBrand(data.target.value)
                          }}

                          // placeholder="Enter Project Owner"
                        />
<FieldError msg={errors.brand} />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="exampleInputEmail1">Type</label>
                        <Select classNamePrefix="rs" menuPortalTarget={document.body} menuPosition="fixed" options={typeOption} value={type} onChange={(data)=> setType({
                                value: data?.value,
                                label: data?.label,
                              })}/>
<FieldError msg={errors.type} />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="exampleInputEmail1">Assign To</label>
                        <Select classNamePrefix="rs" menuPortalTarget={document.body} menuPosition="fixed" options={helperData} value={assign} onChange={(data)=>{
                          setAssign({
                            value: data?.value,
                            label: data?.label,
                          })
                        }}/>
<FieldError msg={errors.assign} />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="row mb-5 mt-4 ml-2">
                        <div className="">
                          <LoadingButton className="create-button" successLabel="Saved" onAction={updateInventort}>
                            Update
                          </LoadingButton>
                        </div>
                        <div className="ml-2">
                          <Link to="/inventory-listing">
                          <button
                            type="button"
                            className="create-button1 btn-info"
                          >
                            Cancel
                          </button></Link>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12"></div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditInveintory;
